import {NgModule} from '@angular/core';
import {StdCommonComponent} from './std-common.component';
import {CommonModule} from '@angular/common';
import {StdTableComponent} from './components/std-table/std-table.component';
import {StdObjectsComponent} from './std-objects.component';
import {AccordionModule} from '@components/accordion/accordion.module';
import {StdLayoutComponent} from './components/std-layout/std-layout.component';
import {StdMethodsComponent} from './std-methods.component';
import {StdAddModalComponent} from './components/std-add-modal/std-add-modal.component';
import {ModalModule} from '@components/modal/modal.module';
import {ReactiveFormsModule} from '@angular/forms';
import {FormFieldModule} from '@components/form-field/form-field.module';
import {LayoutModule} from '../../../../../layout-components/layout.module';

@NgModule({
    imports: [
        CommonModule,
        AccordionModule,
        ModalModule,
        ReactiveFormsModule,
        FormFieldModule,
        LayoutModule,
    ],
    exports: [
        StdCommonComponent,
        StdObjectsComponent,
        StdMethodsComponent,
    ],
    declarations: [
        StdCommonComponent,
        StdObjectsComponent,
        StdMethodsComponent,

        StdTableComponent,
        StdLayoutComponent,
        StdAddModalComponent,
    ],
    providers: [],
})
export class StdModule {
}
